export default __webpack_public_path__ + "static/media/unstaking-step-three-raze.1faedee9.svg";